import React from "react";
import { Link } from "react-router-dom";
//import apoio from "../images/plano.png";
//import apoio2 from "../images/plano2.png";
//import apoio3 from "../images/plano3.png";
//import styles from "../styles/styles.css";

const Precos = props => {
  return (
    <div id="pricing" className="container-fluid">
      <div className="text-center">
        <h2>PLANOS RESIDENCIAIS</h2>
        <h4>Escolha o melhor tipo de plano para a sua residência</h4>
      </div>
      <div className="row ">
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-bronze">
              <h1>BRONZE</h1>
            </div>
            <div className="panel-body"></div>
            <div className="panel-footer-bronze">
              <Link className="btn btn-lg" to="/contato">
                Solicite uma visita
              </Link>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-prata">
              <h1>PRATA</h1>
            </div>
            <div className="panel-body"></div>
            <div className="panel-footer-prata">
              <Link className="btn btn-lg" to="/contato">
                Solicite uma visita
              </Link>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-ouro">
              <h1>OURO</h1>
            </div>
            <div className="panel-body"></div>
            <div className="panel-footer-ouro"></div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-diamante">
              <h1>DIAMANTE</h1>
            </div>
            <div className="panel-body"></div>
            <div className="panel-footer-diamante"></div>
          </div>
        </div>
      </div>
      <br></br>
      <div className="text-center">
        <h2>PLANOS EMPRESARIAIS</h2>
        <h4>Escolha o melhor tipo de plano para sua empresa</h4>
      </div>
      <div className="row ">
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-bronze">
              <h1>BRONZE</h1>
            </div>
            <div className="panel-body"></div>
            <div className="panel-footer-bronze">
              <Link className="btn btn-lg" to="/contato">
                Solicite uma visita
              </Link>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-prata">
              <h1>PRATA</h1>
            </div>
            <div className="panel-body"></div>
            <div className="panel-footer-prata"></div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-ouro">
              <h1>OURO</h1>
            </div>
            <div className="panel-body"></div>
            <div className="panel-footer-ouro"></div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-diamante">
              <h1>DIAMANTE</h1>
            </div>
            <div className="panel-body"></div>
            <div className="panel-footer-diamante"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Precos;

/** 
 * <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-ouro">
              <h1>OURO</h1>
            </div>
            <div className="panel-body">
              <p>
                <strong /> Uso do APP “PW Condominio Virtual” .
              </p>
              <p>
                <strong /> Acompanhamento de entrada/saída com direito a 4
                acionamentos.
              </p>
              <p>Botão de Pânico.</p>
              <p>
                <strong /> Apoio Armado.
              </p>
              <p>
                <strong /> Parada aleatória.
              </p>
            </div>
            <div className="panel-footer-ouro">
              <h3>R$ 89,90</h3>
              <h4>por mês</h4>
              <Link className="btn btn-lg" to="/contato">
                Solicite uma visita
              </Link>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-diamante">
              <h1>DIAMANTE</h1>
            </div>
            <div className="panel-body">
              <p>
                <strong /> Uso do APP “PW Condominio Virtual” .
              </p>
              <p>
                <strong /> Acompanhamento de entrada/saída com direito a 4
                acionamentos.
              </p>
              <p>Botão de Pânico.</p>
              <p>
                <strong /> Apoio Armado.
              </p>
              <p>
                <strong /> Parada aleatória.
              </p>
              <p>
                <strong /> Escolta veicular com direito a 2 acionamentos.
              </p>
            </div>
            <div className="panel-footer-diamante">
              <h3>R$ 99,90</h3>
              <h4>por mês</h4>
              <Link className="btn btn-lg" to="/contato">
                Solicite uma visita
              </Link>
            </div>
          </div>
        </div>

        //emprersarial
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-prata">
              <h1>STANDARD</h1>
            </div>
            <div className="panel-body">
              <p>
                <strong /> Uso do APP “PW Condominio Virtual” .
              </p>
              <p>
                <strong /> Acompanhamento de entrada/saída com direito a 4
                acionamentos.
              </p>
              <p>Botão de Pânico.</p>
              <p>
                <strong /> Apoio Armado.
              </p>
              <p>
                <strong /> Adicionar empresa no aplicativo.
              </p>
            </div>
            <div className="panel-footer-prata">
              <h3>R$ 89,90</h3>
              <h4>por mês</h4>
              <Link className="btn btn-lg" to="/contato">
                Solicite uma visita
              </Link>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-ouro">
              <h1>ENTERPRISE</h1>
            </div>
            <div className="panel-body">
              <p>
                <strong /> Uso do APP “PW Condominio Virtual” .
              </p>
              <p>
                <strong /> Acompanhamento de entrada/saída com direito a 4
                acionamentos.
              </p>
              <p>Botão de Pânico.</p>
              <p>
                <strong /> Apoio Armado.
              </p>
              <p>
                <strong /> Adicionar empresa no aplicativo.
              </p>
              <p>
                <strong /> Parada Aleatória quanda a empresa estiver aberta 2
                paradas.
              </p>
            </div>
            <div className="panel-footer-ouro">
              <h3>R$ 119,90</h3>
              <h4>por mês</h4>
              <Link className="btn btn-lg" to="/contato">
                Solicite uma visita
              </Link>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading-diamante">
              <h1>PREMIUM</h1>
            </div>
            <div className="panel-body">
              <p>
                <strong /> Uso do APP “PW Condominio Virtual” .
              </p>
              <p>
                <strong /> Acompanhamento de entrada/saída com direito a 4
                acionamentos.
              </p>
              <p>Botão de Pânico.</p>
              <p>
                <strong /> Apoio Armado.
              </p>
              <p>
                <strong /> Adicionar empresa no aplicativo.
              </p>
              <p>
                <strong /> Parada Aleatória quanda a empresa estiver aberta 2
                paradas.
              </p>
              <p>
                <strong /> Sangria Até o local de guarda.
              </p>
            </div>
            <div className="panel-footer-diamante">
              <h3>R$ 129,90</h3>
              <h4>por mês</h4>
              <Link className="btn btn-lg" to="/contato">
                Solicite uma visita
              </Link>
            </div>
          </div>
        </div>
        
*/
